<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Vendedores
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/LOGO ITALVEN.png', style='height: auto;width: 160px;border-radius:5px;padding:5px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Vendedores
    v-dialog(v-model='dialog2', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Vendedor
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md6, sm6)
                          v-form(enctype="multipart/form-data")

                            v-autocomplete(outline
                            v-model="form2.zonas"
                            :items='zonas'
                            multiple
                            prepend-inner-icon="description"
                            label="Zonas:")

                            v-checkbox(v-model='checkk' label='Asignar todas las zonas' color='#048420' hide-details='' style='margin-bottom: 20px;')

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:#e42e28;border-radius:10px;", @click.native='guardar') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close2') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Vendedores
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td(v-if='props.item.co_ven') {{props.item.co_ven}}
            td(v-else) - -
            td(v-if='props.item.ven_des') {{props.item.ven_des}}
            td(v-else) - -
            td(v-if='props.item.zonas && props.item.zonas.length > 0') Si
            td(v-else) No
            td.justify-start.layout.px-0
              v-btn.mx-0(icon, @click='editItem2(props.item)', style='margin-top: -7px;')
                  v-icon(color='teal') add_box
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Vendedores",
  data: () => ({
    ruta: serverImg,
    loading: false,
    resultados: [],
    show1: false,
    checkk: false,
    form2: {
      co_ven: "",
      zonas: [],
    },
    dialog2: false,
    zonas: [],
    headers: [
      { text: "Codigo", value: "co_ven" },
      { text: "Vendedor", value: "ven_des" },
      { text: "Zonas", value: "zonas" },
      { text: "Acción" }
    ],
    defaultForm2: {
      co_ven: "",
      zonas: [],
    },
  }),
  watch: {
    checkk(val) {
      if (val) {
        this.form2.zonas = [];
        for (let i = 0; i < this.zonas.length; i++) {
          const el = this.zonas[i];
          this.form2.zonas.push(el.value)
        }
      } else {
        this.form2.zonas = [];
      }
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.checkk = false;
      Api.get2("vendedor/icono").then(res => {
        this.resultados = res.data;
      });
      Api.get2("zonas").then(res => {
        this.zonas = [];
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          this.zonas.push({value: el.co_zon, text: el.zon_des.trim()})
        }
      });
    },
    close2() {
      this.checkk = false;
      this.form2 = Object.assign({}, this.defaultForm2);
      this.dialog2 = false;
    },
    editItem2(item) {
      Object.keys(this.form2).map(key => {
        if (item[key]) this.form2[key] = item[key];
      });
      this.dialog2 = true;
    },
    guardar() {
      if (this.form2.zonas && this.form2.zonas.length > 0) {
        this.loading = true
        Api.put2("vendedor", this.form2)
            .then(res => {
              if (res.data.status === "succes") {
                this.form2 = Object.assign({}, this.defaultForm2);
                this.dialog2 = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
                this.initialize();
              } else {
                this.loading = false;
                this.$swal.fire(
                  "¡Atención!",
                  res.data.error,
                  "error"
                );
              }
            })
            .catch(err => {
              console.log(err);
              this.loading = false;
              this.$swal.fire(
                "Oops...",
                "Error encontrado, verifique los datos o llame al administrador.",
                "error"
              );
        });
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Estimado usuario, para continuar con la operación debe ingresar todos los datos solicitados.",
          "error"
        );
      }
    }
  }
};
</script>
